// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__Ch1v2","table":"Table_table__8LBzN","row":"Table_row__WYYSw","col":"Table_col__zLx58","status":"Table_status__UYMrk"};